import { useMutation } from '@apollo/client';
import { gql } from '__generated__';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';

import ConfirmButton from 'components/ConfirmButton';

const REMOVE_USER_MUTATION = gql(`
  mutation RemoveUser($id: ID!) {
    removeUser(id: $id) {
      id
    }
  }
`);

const DeleteUserButton: FC<{ id: string; departmentId: string }> = ({ id, departmentId }) => {
  const navigate = useNavigate();

  const [removeUser, { loading, error }] = useMutation(REMOVE_USER_MUTATION, {
    variables: { id },
    refetchQueries: ['DepartmentUsers'],
    update(cache) {
      cache.evict({ id: cache.identify({ __typename: 'UserType', id }) });
      cache.gc();
    },
    onCompleted() {
      navigate(`/departments/${departmentId}/users`);
    },
  });

  return (
    <ConfirmButton
      onConfirm={removeUser}
      loading={loading}
      error={error}
      title="Delete employee?"
      description="This will permanently delete this employee and all related data, including identity cards and documents. This cannot be undone."
      confirmButtonLabel="Delete"
    >
      Delete Employee
    </ConfirmButton>
  );
};

export default DeleteUserButton;
